import { LEARNING_GOAL_OPTIONS } from 'bundles/onboarding-common/constants';
import { useOnboardingOptions } from 'bundles/onboarding-common/contexts/OnboardingOptionsContext';

const useIsAdvancer = () => {
  const { learningGoal } = useOnboardingOptions();

  return learningGoal === LEARNING_GOAL_OPTIONS.LEARNING_GOAL_IMPROVE_SKILLS;
};

export default useIsAdvancer;
